import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "modal full galleryImageDetailModal" }
const _hoisted_2 = {
  class: "modal_body",
  ref: "modalBody"
}
const _hoisted_3 = {
  key: 0,
  class: "d-flex align-items-center justify-content-center"
}
const _hoisted_4 = { class: "d-flex justify-content-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "CHIUDI", -1)
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_qrcode = _resolveComponent("vue-qrcode")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.loaded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_vue_qrcode, {
              value: _ctx.identifier,
              options: {
                        color: {
                            dark: '#ffffff',
                            light: '#1C1C1C',
                        },
                        width: _ctx.widthCustom
                    },
              class: "qrcode mt-5"
            }, null, 8, ["value", "options"])
          ]))
        : _createCommentVNode("", true)
    ], 512),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        class: "w-100 btn btn-primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_6)
    ])
  ]))
}